import { render } from "./health.vue?vue&type=template&id=c629f01c&scoped=true"
import script from "./health.vue?vue&type=script&lang=js"
export * from "./health.vue?vue&type=script&lang=js"

import "./health.vue?vue&type=style&index=0&id=c629f01c&scoped=true&lang=css"

import exportComponent from "D:\\html\\bracelet-management-system\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c629f01c"]])

export default __exports__